import React from 'react';
import Box from "@mui/material/Box";
import Marquee from "../../../components/marquee/Marquee";
import {useTranslation} from "react-i18next";

function OnSaleLine({productPromo}) {
    const {t} = useTranslation();

    const getText = () => {
        let text = t('productPromo.line.onSale');
        const textArray = [text];

        if (productPromo['1']) {
            textArray.push(`${t('productPromo.line.piece', { piece: '1', promoPercent: (productPromo['1'] * 100) })}`);
        }

        Object.keys(productPromo).filter(pc => pc !== '1').forEach(pc => {
            textArray.push(`${t('productPromo.line.pieces', { piece: pc, promoPercent: (productPromo[pc] * 100) })}`);
        })


        return textArray.map(textPiece => <Box sx={{px: {xs: 5, md: 7}, fontSize: {xs: '13px', md: '15px'}, fontWeight: 500}}>{textPiece}</Box>);
    }

    return (
        <Box className="onsaleline" sx={{backgroundColor: '#7abf98', color: 'white', textAlign: 'center', p: '3px 0', overflow: 'hidden'}}>
            <Marquee objects={getText()} sec={20}/>
        </Box>
    );
}

export default OnSaleLine;
